var map = {
	"./BUSDicon.png": 1151,
	"./Binance-USD-BUSD-The-Giving-Block.png": 762,
	"./Ethereum-ETH-icon.png": 763,
	"./bnb.svg": 1152,
	"./bnbs.png": 764,
	"./bsc.png": 1153,
	"./busd.svg": 1154,
	"./cMatic.png": 765,
	"./cavax.png": 766,
	"./coinbase.png": 1155,
	"./dai.png": 1156,
	"./eth.png": 635,
	"./fizen.png": 1157,
	"./logoera.png": 697,
	"./metamask.png": 1158,
	"./polygon-matic-logo.svg": 1159,
	"./polygon.png": 1160,
	"./rainbow.png": 1161,
	"./trustwallet.png": 1162,
	"./usd-coin-usdc-logo.png": 767,
	"./usdt.svg": 1163,
	"./walletconnect.png": 1164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 636;